import {Pointer} from "./pointer.js";

/**
 * Pointers hovering above the racecrafts
 */
export class Pointers {
    static CLASS_VISIBLE = "visible";

    /**
     * Construct the pointers
     * @param {HTMLElement} element The element
     * @param {Racers} racers The racers
     */
    constructor(element, racers) {
        this.element = element;
        this.pointers = [];
        this.visible = false;

        for (const racer of racers.racers) {
            const pointer = new Pointer(racer);

            this.pointers.push(pointer);

            element.appendChild(pointer.element);
        }

        this.setVisible(true);
    }

    /**
     * Make all pointers big
     */
    makeBig() {
        for (const pointer of this.pointers)
            pointer.setSmall(false);
    }

    /**
     * Make all pointers small
     */
    makeSmall() {
        for (const pointer of this.pointers)
            pointer.setSmall(true);
    }

    /**
     * Set visibility of pointers
     * @param {boolean} visible True if visible, false if not
     */
    setVisible(visible) {
        if (this.visible = visible)
            this.element.classList.add(Pointers.CLASS_VISIBLE);
        else
            this.element.classList.remove(Pointers.CLASS_VISIBLE);
    }

    /**
     * Update before rendering
     * @param {number} time The time interpolation in the range [0, 1]
     * @param {Camera} camera The camera
     * @param {number} width The screen width in pixels
     * @param {number} height The screen height in pixels
     */
    render(time, camera, width, height) {
        if (this.visible) {
            this.pointers.sort((a, b) => b.screenPosition.y - a.screenPosition.y);

            for (let pointer = 0, pointerCount = this.pointers.length; pointer < pointerCount; ++pointer)
                this.pointers[pointer].render(time, camera, width, height, pointer);
        }
    }

    /**
     * Clear all pointers
     */
    clear() {
        for (const pointer of this.pointers)
            this.element.removeChild(pointer.element);
    }
}